import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { FormControl } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../service/cpm.service'
import { StoreService } from '../../service/store.service'

@Component({
  selector: 'app-ae-summary-visit-summary-by-individual',
  templateUrl: './ae-summary-visit-summary-by-individual.component.html',
  styleUrls: ['./ae-summary-visit-summary-by-individual.component.scss']
})
export class AeSummaryVisitSummaryByIndividualComponent implements OnInit {
  @Input() printPage
  @Output() changeYearByIndividual: EventEmitter<string> = new EventEmitter()
  listTable
  listHeader
  listNewCase = []
  listConCase = []
  listShow = []
  team = []
  listTeam = []
  listForTable = []
  checkConCase = false
  listTotalN = []
  listTotalC = []
  type = []
  listNCTotal = []
  listCCTotal = []
  totalOfC
  totalOfN
  listYear
  nameHead = []
  selectedVisitSummaryByIndividual
  listData
  yearControl = new FormControl()
  checkDisplayTotal = false
  constructor(
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const { yearByIndividual } = this.activatedRoute.snapshot.params
    this.listYear = []

    let year = new Date().getFullYear()
    for (let i = year - 2; i <= year; i++) {
      this.listYear.push(i)
    }
    this.listYear.sort((a, b) => 0 - (a > b ? 1 : -1))
    this.selectedVisitSummaryByIndividual = this.listYear[0]
    if (yearByIndividual !== undefined) {
      year = yearByIndividual
    }
    this.yearControl.valueChanges.subscribe(value => {
      this.changeYearByIndividual.emit(value)
    })
    this.yearControl.setValue(year)

    this.onChangeData()
  }
  onChangeData() {
    this.cpmService
      .getSummaryByIndividual(this.yearControl.value)
      .then(success => {
        this.listTable = []
        this.listHeader = []
        this.listData = []
        this.listData = success
        success.map(obj => {
          const lsData = {
            teams: obj.employee
          }
          this.listTable.push(lsData)
          this.nameHead.push(obj.departmentName)
        })
        success.length === 0
          ? (this.checkDisplayTotal = true)
          : (this.checkDisplayTotal = false)
        this.listHeader = [
          'Team',
          'Name Surname',
          'Type',
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'July',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
          'Total'
        ]
        this.createTable()
      })
  }
  checkContinueCase(con) {
    return con === 'Continue case'
      ? (this.checkConCase = true)
      : (this.checkConCase = false)
  }
  forTotal(value) {
    return value.reduce((a, b) => a + b, 0)
  }
  createTable() {
    this.listNCTotal = []
    this.listNewCase = []
    this.listCCTotal = []
    this.listConCase = []
    this.listTable.map(ls => {
      ls.teams.map(obj => {
        obj.numberOfCase.map(t => {
          if (t.type === 'New case') {
            const data = {
              team: obj.firstNameEng + ' ' + obj.lastNameEng,
              type: t.type,
              value: t.value.reduce((a, b) => a + b, 0)
            }
            const dataTotal = {
              team: obj.firstNameEng + ' ' + obj.lastNameEng,
              type: t.type,
              value: t.value
            }
            this.listNCTotal.push(dataTotal)
            this.listNewCase.push(data)
          } else if (t.type === 'Continue case') {
            const data = {
              team: obj.firstNameEng + ' ' + obj.lastNameEng,
              type: t.type,
              value: t.value.reduce((a, b) => a + b, 0)
            }
            const dataTotal = {
              team: obj.firstNameEng + ' ' + obj.lastNameEng,
              type: t.type,
              value: t.value
            }
            this.listCCTotal.push(dataTotal)
            this.listConCase.push(data)
          }
        })
      })
    })
    this.listShow = []
    this.listTable.map(ls => {
      ls.teams.map(obj => {
        this.type.push(obj.type)
        if (obj.firstNameEng === obj.firstNameEng) {
          obj.numberOfCase.map(t => {
            const data = {
              team: obj.firstNameEng + ' ' + obj.lastNameEng,
              type: t.type,
              value: t.value
            }
            this.listShow.push(data)
          })
        }
      })
    })
    this.listShow.map(sh => {
      this.nameHead.map(head => {
        this.listData.map(data => {
          data.employee.map(employ => {
            if (sh.team === employ.firstNameEng + ' ' + employ.lastNameEng && data.departmentName === head) {
              sh['department'] = head
            }
          })
        })
      })
    })
    this.nameHead.map(header => {
      this.listShow.filter(show => show.department === header).map((objShow, i) => {
        if (i !== 0) {
          objShow.department = '';
        }
      })
    })


    this.type = this.type.reduce(function (a, b) {
      if (a.indexOf(b) < 0) {
        a.push(b)
      }
      return a
    }, [])
    this.listTotalC = []
    this.listTotalN = []
    const janN = []
    const febN = []
    const marN = []
    const aprN = []
    const mayN = []
    const juneN = []
    const julyN = []
    const augN = []
    const sepN = []
    const octN = []
    const novN = []
    const decN = []
    this.listNCTotal.map(show => {
      janN.push(show.value[0])
      febN.push(show.value[1])
      marN.push(show.value[2])
      aprN.push(show.value[3])
      mayN.push(show.value[4])
      juneN.push(show.value[5])
      julyN.push(show.value[6])
      augN.push(show.value[7])
      sepN.push(show.value[8])
      octN.push(show.value[9])
      novN.push(show.value[10])
      decN.push(show.value[11])
    })
    this.listTotalN.push(
      this.forTotal(janN),
      this.forTotal(febN),
      this.forTotal(marN),
      this.forTotal(aprN),
      this.forTotal(mayN),
      this.forTotal(juneN),
      this.forTotal(julyN),
      this.forTotal(augN),
      this.forTotal(sepN),
      this.forTotal(octN),
      this.forTotal(novN),
      this.forTotal(decN)
    )
    const janC = []
    const febC = []
    const marC = []
    const aprC = []
    const mayC = []
    const juneC = []
    const julyC = []
    const augC = []
    const sepC = []
    const octC = []
    const novC = []
    const decC = []
    this.listCCTotal.map(show => {
      janC.push(show.value[0])
      febC.push(show.value[1])
      marC.push(show.value[2])
      aprC.push(show.value[3])
      mayC.push(show.value[4])
      juneC.push(show.value[5])
      julyC.push(show.value[6])
      augC.push(show.value[7])
      sepC.push(show.value[8])
      octC.push(show.value[9])
      novC.push(show.value[10])
      decC.push(show.value[11])
    })
    this.listTotalC.push(
      this.forTotal(janC),
      this.forTotal(febC),
      this.forTotal(marC),
      this.forTotal(aprC),
      this.forTotal(mayC),
      this.forTotal(juneC),
      this.forTotal(julyC),
      this.forTotal(augC),
      this.forTotal(sepC),
      this.forTotal(octC),
      this.forTotal(novC),
      this.forTotal(decC)
    )
    this.totalOfC = this.forTotal(this.listTotalC)
    this.totalOfN = this.forTotal(this.listTotalN)
  }

  get ws_data_toExcel() {
    const ws_data = [];

    if (!this.checkDisplayTotal) {
      ws_data.push([...this.listHeader])
    }
    this.listShow.map(lists => {
      this.checkContinueCase(lists.type);

      const filters = {
        type: lists.type,
        team: lists.team
      }
      const totalN = this.cpmService.multiFilter(this.listNewCase, filters).map(newCase => { return newCase.value });
      const totalC = this.cpmService.multiFilter(this.listConCase, filters).map(conCase => { return conCase.value });
      let totalValue;

      if (totalC.length > 0) {
        totalValue = totalC;
      } else {
        totalValue = totalN;
      }

      ws_data.push([lists.department, this.checkConCase ? ' ' : lists.team, lists.type, ...lists.value, totalValue]) // ,  totalC

    });

    if (!this.checkDisplayTotal) {
      ws_data.push(['Total', '', 'New case', ...this.listTotalN, this.totalOfN]);
      ws_data.push(['', '', 'Continue case', ...this.listTotalC, this.totalOfC]);
    }

    return ws_data;
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/ae-summary-visit-summary-by-individual/ae-summary-visit-summary-by-individual.component.ts